import { render } from "./email-template.vue?vue&type=template&id=4c057d4e"
import script from "./email-template.vue?vue&type=script&lang=js"
export * from "./email-template.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__